import React, { useState, useContext } from 'react';
import { Select, DatePicker, Modal, Button, Table, Input } from 'antd';
import { GenericButton } from '../../fields/GenericButton';
import { PlusOutlined, DeleteFilled } from '@ant-design/icons';
import uuidv4 from 'uuid/v4';
import { ModelContext } from '../../metadata/ModelSource';
import { dateToString, MULTI_DATE_FORMATS } from '../../../utils/dateUtils';
import _ from 'lodash';

export const MultiCustomUserAttrSummary = ({
  modalTitle,
  option,
  items,
  ...props
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [data, setData] = useState([]);
  const applicationModel = useContext(ModelContext);
  const [editingKey, setEditingKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [indexState, setIndexState] = useState();
  const [editedOccurrenceDate, setEditedOccurrenceDate] = useState();
  const [editedInfraction, setEditedInfraction] = useState();
  const [currentIndex, setCurrentIndex] = useState();
  const prefixPath = `coverageItems[]`;
 
  // const columns = () => {
  //   if (option.productScheduledItems) {
  //     const fieldColumn = option.productScheduledItems.attributes.attributes.map(
  //       (item, index) => {
  //         return {
  //           title: item.label,
  //           dataIndex: item.id,
  //           key: index,
  //           width: 300,
  //         };
  //       }
  //     );
  //     return fieldColumn;
  //   }
  //   if (option.productScheduledLocations) {
  //     const fieldColumn = option.productScheduledLocations.attributes.attributes.map(
  //       (item, index) => {
  //         // setIndexState(index)
  //         return {
  //           title: item.label,
  //           dataIndex: item.id,
  //           key: index,
  //           width: 300,
  //         };
  //       }
  //     );
  //     return fieldColumn;
  //   }
  // };

  const columns = [
    {
      title: 'Address #',
      dataIndex: 'addressIndex',
      key: 'addressIndex',
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: '# of Families',
      dataIndex: 'numOfFam',
      key: 'numOfFam',
    },
    {
      title: '',
      dataIndex: 'operation',
      align: 'right',
      render: (text, record, index) => {
        return (
          <div
            style={{
              display: 'flex',
              width: '80px',
              align: 'right',
            }}
          >
            <DeleteFilled
              className={'delete-infraction'}
              onClick={() =>cancelEdit(record, index)}
              style={{ fontSize: '20px', color: '#2a333e' }} />
          </div>
        );
      },
    },
  ];

  const typeField = option.productScheduledItems
    ? option.productScheduledItems.attributes.attributes[1]
    : null;
  const SPPcolumns = [
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Appraisal Date',
      dataIndex: 'appraisalDate',
    },
    {
      title: 'Coverage Amount',
      dataIndex: 'coverageAmount',
    },
    {
      title: '',
      dataIndex: 'operation',
      width: 200,
      align: 'right',
      render: (text, record, index) => {
        return (
          <div
            style={{
              display: 'flex',
              width: '80px',
              align: 'right',
            }}
          >
            <DeleteFilled
              className={'delete-infraction'}
              onClick={() =>cancelEdit(record, index)}
              style={{ fontSize: '20px', color: '#2a333e' }} />
          </div>
        );
      },
    },
  ];

  const deleteCoverage = (record, index, cancelDelete) => {
    const newData = [...data];
    let container = applicationModel.getValue(prefixPath);
    const currentInfraction = container[index];
    setLoading(true);

    if (currentInfraction.id) {
      container.forEach((infraction, index) => {
        if (infraction.id === currentInfraction.id) {
          infraction.status = 'Deleted';
        }
      });
    } else {
      container.splice(
        container.findIndex((infraction) => {
          return infraction._tempId === currentInfraction._tempId;
        }),
        1
      );
    }

    newData.splice(
      newData.findIndex((infraction) => {
        return infraction._tempId === currentInfraction._tempId;
      }),
      1
    );

    if (cancelDelete) {
      setLoading(false);
      // setEditingKey('');
      setCurrentIndex();
      setData(newData);
      applicationModel.modification();
    }

    setTimeout(() => {
      setLoading(false);
      // setEditingKey('');
      setCurrentIndex();
      setData(newData);
      applicationModel.modification();
    }, 1000);
  };

  const cancelEdit = (record, index) => {
    const newData = [...data];
    let container = applicationModel.getValue(prefixPath);
    const item = newData[index];
    const formItem = container[index];

    if (
      !formItem.address ||
      !formItem.addressIndex ||
      !formItem.numOfFam ||
      item._saved === false
    ) {
      setData(newData);
      setDisabled(false);
      // setEditingKey('');
      setEditedInfraction('');
      setEditedOccurrenceDate('');
      setCurrentIndex();

      return deleteCoverage(record, index, true);
    }

    newData.splice(index, 1, {
      ...item,
      ...record,
      address: formItem.address,
      addressIndex: formItem.addressIndex,
      numOfFam: formItem.numOfFam
    });

    setData(newData);
    setDisabled(false);
    // setEditingKey('');
    setCurrentIndex();
    setEditedInfraction('');
    setEditedOccurrenceDate('');
  };

  const handleDateSelect = (value) => {
    setEditedOccurrenceDate(dateToString(value));
  };

  const addCoverageItem = (isSPP) => {
    const tempId = uuidv4();
    let container = applicationModel.getValue(prefixPath);

    if (container === undefined) {
      container = [];
      applicationModel.setValue(prefixPath, container);
    }

    const newData = [...data];
    const key = newData.length;
    const newInfraction = {
      key,
      _tempId: tempId,
      _saved: false,
    };

    container.push(newInfraction);

    // setEditingKey(key);
    setDisabled(true);

    if (isSPP) {
      newData.push({
        ...newInfraction,
        description: <Input></Input>,
        type: <TypeSelect />,
        coverageAmount: <Input></Input>,
        appraisalDate: (
          <DatePicker
            aria-label='Select coverage date'
            format={MULTI_DATE_FORMATS}
            onChange={handleDateSelect}
          />
        ),
      });
    }
  
    let addressIndexDisplay = 1;
    addressIndexDisplay = newData.map((v) => _.get(v, "key"));
    if(addressIndexDisplay === 0) {
      addressIndexDisplay = 1
    } else {
      addressIndexDisplay + 1
    }
    newData.push({
      ...newInfraction,
      addressIndex: addressIndexDisplay.slice(-1),
      address: <Input></Input>,
      numOfFam: <Input></Input>,
    });

    setData(newData);
    applicationModel.modification();
  };

  const determineTableDisplay = () => {
    if (option.printDesc === 'Scheduled Personal Property') {
      return (
        <React.Fragment>
          <GenericButton
            label='Add'
            onClick={() => addCoverageItem(true)}
            type='primary'
            style={{ position: 'absolute', right: '0px', margin: '0px 16px' }}
          />
          <Table
            bordered={false}
            pagination={false}
            dataSource={data}
            columns={SPPcolumns}
            style={{ marginTop: '32px' }}
          />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <GenericButton
            label='Add'
            onClick={() => addCoverageItem(false)}
            type='primary'
            style={{ position: 'absolute', right: '0px', margin: '0px 16px' }}
          />
          <Table
            bordered={false}
            pagination={false}
            dataSource={data}
            columns={columns}
            style={{ marginTop: '32px' }}
          />
        </React.Fragment>
      );
    }
  };

  const handleSelect = (value) => {
    setEditedInfraction(value);
  };

  const propertyPath = option.productScheduledItems
    ? option.productScheduledItems.productScheduledItem
    : null;

  const TypeSelect = ({ previousValue, loading }) => (
    <Select
      defaultValue={previousValue ? previousValue : ''}
      onChange={handleSelect}
      style={{ width: '200px' }}
      loading={loading}
      showSearch
    >
      {propertyPath &&
        propertyPath.map((infraction, index) => (
          <Option key={index} value={infraction.shortDesc}>
            {infraction.shortDesc}
          </Option>
        ))}
    </Select>
  );

  return (
    <div>
      <Modal
        title={option.printDesc}
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <button
            className='cancel-button'
            key='back'
            onClick={() => setModalVisible(false)}
          >
            Cancel
          </button>,
          <Button
            loading={loading}
            key='submit'
            type='primary'
            // onClick={() => saveCoverage()}
          >
            Save
          </Button>,
        ]}
        className={'additional-coverages-modal'}
      >
        {determineTableDisplay()}
      </Modal>
      <GenericButton
        icon={<PlusOutlined />}
        label='Add Residence'
        onClick={() => setModalVisible(true)}
        type='primary'
      />
    </div>
  );
};